import React, { Component } from 'react'
import { computed } from 'mobx'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'

import withAppStore from 'decorators/withAppStore'
import authorized from 'decorators/authorized'

import LoadingPage from 'components/LoadingPage'
import ServiceCard from 'components/ServiceCard'

import getServices from 'tasks/getServices'

import styles from 'styles/pages/dashboard'

@withStyles(styles)
@authorized
@withAppStore
@observer
export default class extends Component {

  @computed
  get activeServices() {
    return getServices.result.filter(service => service.active)
  }

  componentWillMount() {
    this.appStore.pageTitle = 'Обзор'
    getServices.perform()
  }

  render() {
    const { classes } = this.props

    return (
      <div className={ classes.root } >
        { this.activeServices.length ? this.activeServices.map(( service, index ) => (
          <ServiceCard service={ service } key={ index } />
        )) : getServices.isRunning &&
          <LoadingPage visible />
        }
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard.js